import { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface Head5Props {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters';
  overflow?: 'hidden' | 'visible';
  as?: keyof JSX.IntrinsicElements;
}

const Head5 = ({
  children,
  maxLines = 2,
  className = '',
  isClamp = false,
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  as: Tag = 'h5',
  ...props
}: Head5Props & React.ComponentProps<typeof Tag>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );

  return (
    <Tag
      style={{ ...lineClampStyle, ...style }}
      className={`text-[18px] leading-[24px] font-semibold text-black90 ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Head5;
